import { logError } from "infrastructure/log";
import { translate as t } from "infrastructure/translate/localization";
import { findCompanyId } from "infrastructure/repository/company-repository";
import * as repository from "infrastructure/repository/employees-repository";
import { showErrorMessage } from "usecases/commons/show-error-message";
import { showSuccessMessage } from "usecases/commons/show-success-message";

type updateEmployeesStatusParams = {
  employees: {
    employeeId: string;
    status?: string;
    note?: string;
  }[];
};

export async function updateEmployeesStatus({
  employees,
}: updateEmployeesStatusParams) {
  try {
    const companyId = await findCompanyId();
    if (!companyId || employees.length === 0) return;

    const payload = {
      companyId,
      employees: employees.map(
        ({ employeeId, status = "active", note = " " }) => ({
          employeeId,
          status,
          note,
        })
      ),
    };

    await repository.updateEmployeesStatus(payload);
    showSuccessMessage(t("employees-section.restore-modal.success-message"));
  } catch (e) {
    // @ts-ignore
    logError(e, `Error to change employee status`);
    showErrorMessage(t("common-messages.basic-error-message"), true);
    throw new Error(e as string);
  }
}
